import React, { useEffect } from 'react';
import { composer } from '../../../component-decorators/composer';
import { Button } from 'wix-style-react';
import { biLogger } from '../../../bi';
import { getAppSettingsPageUrl, isBundleAppAndInstalled, isBundleAppAndNotInstalled, isBundleAppFromVoucher, isNewVersionAvailable, isPendingApp, isSetupIncomplete, openSettingsUrl, } from '../../..';
export var MainActionButton = composer()
    .withTranslation()
    .withExperiments()
    .compose(function (_a) {
    var mainButtonAction = _a.mainButtonAction, app = _a.app, msid = _a.msid, origin = _a.origin, index = _a.index, t = _a.t, experiments = _a.experiments, getAppInstance = _a.getAppInstance, openModal = _a.openModal, embeddedScriptAppsStatus = _a.embeddedScriptAppsStatus, isActionRequiredApp = _a.isActionRequiredApp, siteIsBusinessFirstSite = _a.siteIsBusinessFirstSite;
    var priority = experiments &&
        experiments.enabled('specs.marketplace.manage-apps.cta-color-change')
        ? 'secondary'
        : 'primary';
    var onClick = function () {
        biLogger
            .openAppClick({
            index: index,
            msid: msid,
            app_id: app.webSolutionBase.id,
            market: origin,
            tag_type: 'manage_apps',
            tag_name: 'manage_apps',
        })
            .catch(function (e) { return console.log(e); });
        mainButtonAction(app);
    };
    var onCTAClick = function () {
        if (isActionRequiredApp) {
            biLogger
                .appMarketManageAppsActionRequiredClick({
                msid: msid,
                app_id: app.webSolutionBase.id,
                market: origin,
                action_cta: getLabel().biLabel,
            })
                .catch(function (e) { return console.log(e); });
        }
        else {
            biLogger
                .openAppClick({
                index: index,
                msid: msid,
                app_id: app.webSolutionBase.id,
                market: origin,
                tag_type: 'manage_apps',
                tag_name: 'manage_apps',
            })
                .catch(function (e) { return console.log(e); });
        }
        if (getAppSettingsPageUrl(app)) {
            openSettingsUrl(app, openModal, embeddedScriptAppsStatus);
        }
        else {
            mainButtonAction(app);
        }
    };
    var getLabel = function () {
        if (isBundleAppAndNotInstalled(app) && isBundleAppFromVoucher(app)) {
            return {
                label: t('manage-apps.business-apps.add-app'),
                biLabel: 'add-voucher-app',
            };
        }
        if (isBundleAppAndNotInstalled(app)) {
            return {
                label: t('manage-apps.business-apps.claim-app'),
                biLabel: 'claim-app',
            };
        }
        if (isBundleAppAndInstalled(app)) {
            return {
                label: t('manage-apps.business-apps.claim-upgrade'),
                biLabel: 'claim-upgrade',
            };
        }
        if (isNewVersionAvailable(app, experiments)) {
            return {
                label: t('manage-apps.business-apps.update-version'),
                biLabel: 'update-version',
            };
        }
        if (isPendingApp(app)) {
            if (siteIsBusinessFirstSite) {
                return {
                    label: t('manage-apps.site-pending.cta'),
                    biLabel: 'create-site',
                };
            }
            return {
                label: t('manage-apps.business-apps.complete'),
                biLabel: 'complete-install',
            };
        }
        if ((experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.complete-setup')) &&
            isSetupIncomplete(app, experiments)) {
            return {
                label: t('manage-apps.business-apps.complete-setup'),
                biLabel: 'complete-setup',
            };
        }
        return {
            label: t('manage-apps.business-apps.open'),
            biLabel: 'open',
        };
    };
    useEffect(function () {
        if (isActionRequiredApp) {
            biLogger
                .appMarketSpotlightArticle({
                action_cta: getLabel().biLabel,
                app_id: app.webSolutionBase.id,
                msid: msid,
                market: origin,
            })
                .catch(function (e) { return console.log(e); });
        }
    }, []);
    return (React.createElement(Button, { size: "tiny", priority: 'primary', onClick: onCTAClick, dataHook: 'main-cta' }, getLabel().label));
});
//# sourceMappingURL=main-action-button.js.map